module.exports = __webpack_public_path__ + "media/images/icons/country_flags/kw-d8ca915f2732310fa0984c2b82ad4d00.svg";